<template>
	<svg
		xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g transform="translate(-1204.5 -854)">
			<path d="M22.75,27.5H4v3.75H22.75ZM34,12.5H4v3.75H34ZM4,23.75H34V20H4ZM4,5V8.75H34V5Z" transform="translate(1208 858.375)"/>
			<path class="a" d="M0,0H45V45H0Z" transform="translate(1204.5 854)"/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-subject',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
  path.a {
    fill: none;
  }
</style>

<docs>
    IconSubject

    ```js
    <b-icon-subject />
    ```
</docs>
